<script lang="ts">
    import { VpEqualizerIcon } from '@decathlon-experience/icons/svelte';
    import { onDestroy, onMount } from 'svelte';

    import { trans } from '$assets/shop-translator.js';
    import cn from '$common/utils/cn';
    import viewport from '$saga/actions/useViewport';
    import Sort from '$saga/views/Search/components/Sort.svelte';
    import {
        arePillarFiltersActive,
        areSecondaryFiltersActive,
    } from '$saga/views/Search/store';

    export let onOpenFilters: () => void;

    let isSticky = false;
    let lastScrollTop = 0;
    let isHidden = false;
    let barElement: HTMLDivElement | null = null;
    let barOriginalTop = 0;

    const handleScroll = () => {
        if (!barElement) return;
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

        // Only hide once the bar is already sticky, so it never disappears above its original position
        if (scrollTop > barOriginalTop) {
            isHidden = scrollTop > lastScrollTop;
        } else {
            isHidden = false;
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    };

    onMount(() => {
        if (barElement) {
            barOriginalTop = barElement.offsetTop + 88;
        }
        window.addEventListener('scroll', handleScroll, { passive: true });
    });

    onDestroy(() => {
        window.removeEventListener('scroll', handleScroll);
    });
</script>

<div
    use:viewport
    on:enterViewport={() => {
        isSticky = false;
    }}
    on:exitViewport={() => {
        isSticky = true;
    }}
></div>

<!--
    used as a placeholder when the bar is sticky
    to avoid layout shift
 -->
{#if isSticky}
    <div
        class="desktop:hidden"
        style="height: {barElement?.clientHeight ?? '88'}px"
    ></div>
{/if}

<div
    bind:this={barElement}
    class={cn(
        'relative flex gap-xs py-l transition-transform duration-300 desktop:hidden',
        isSticky && 'fixed left-0 top-0 z-10 w-full bg-container-quiet px-l',
        isHidden && '-translate-y-full',
    )}
>
    <button
        type="button"
        class={cn(
            'relative top-0 z-20 flex h-8 w-full transform items-center justify-center gap-2xs rounded-full px-m py-xs text-xs',
            'border border-solid border-border-neutral bg-white',
        )}
        on:click={onOpenFilters}
    >
        <span class="flex items-center gap-2xs">
            <VpEqualizerIcon class="size-l" />
            <span>{trans('search.bar.filter')}</span>
            {#if $arePillarFiltersActive || $areSecondaryFiltersActive}
                <div class="h-xl w-fit">
                    <div
                        class="mb-auto size-[7px] rounded-full bg-container-brand"
                    ></div>
                </div>
            {/if}
        </span>
    </button>
    <Sort />
</div>
